/**
 * Error to be used by all services that do data manipulation, if needed.
 */
export class HttpError {
  constructor(
    public readonly status: number,
    public readonly message: string,
    public readonly code?: string,
  ) {}
}
